;
(function(win, UpAct) {
    const CONFIG = {
        /**
         * JAVA域名配置
         */
        originMap: {
           
            dev: 'http://up-events.xingyunzhi.cn', // 开发环境
            stage: 'http://sg-events.pengpengla.com', // 测试环境－新加坡
            pro: 'http://events.upliveapp.com' // 线上环境
        },
        /**
         * PHP域名配置
         */
        originPhpMap: {
            dev: 'http://awsbj-ranking.game.xingyunzhi.cn',
            stage: 'http://sg-ranking.game.xingyunzhi.cn',
            pro: 'https://ranking-game.upliveapp.com'
        },
        /**
         * 根据环境获取Java接口域名
         * @name getOrigin
         */
        getOrigin() {
            // 当前开发环境
            var env = UpAct.BaseUtil.query('env');

            if (!env || env == 'null') {
                env = 'pro';
            }

            var target = this.originMap[env] || this.originMap['pro'];

            if (location.host.indexOf('mact') >= 0) {
                target = target.replace('upliveapp.com', 'upliveapps.com');
            }

            return target;
        },
        /**
         * 根据环境获取PHP接口
         */
        getOriginPhp() {
            // 当前开发环境
            var env = UpAct.BaseUtil.query('env');

            if (!env || env == 'null') {
                env = 'pro';
            }

            var target = this.originPhpMap[env] || this.originPhpMap['pro'];

            if (location.host.indexOf('mact') >= 0) {
                target = target.replace('upliveapp.com', 'upliveapps.com');
            }

            return target;
        },
        /**
         * 获取活动id
         */
        getActivityId() {
            let acid = UpAct.BaseUtil.query('acid');
            let ret = '';

            if (acid) {
                ret = this.acid = acid;
            } else {
                if ($.isArray(this.acid)) {
                    let arr = [];

                    this.acid.forEach(function(item, index) {
                        arr[arr.length] = item.acid;
                    });

                    ret = arr.join(',');
                } else if (typeof this.acid == 'function') {
                    ret = this.acid = this.acid();
                } else {
                    ret = this.acid;
                }
            }

            return ret;
        },
        /**
         * 获取活动信息
         */
        getActInfo() {
            let acid = this.getActivityId();
            let url ;

            if ((acid + '').indexOf(',') > -1) {
                url = this.getOriginPhp() + '/activity/get-multiple-infos?activityIds=' + acid
            } else {
                url = this.getOriginPhp() + '/activity/get-info?activityId=' + acid;
            }

            return this.mockMode == 1 ? 'http://www.mocky.io/v2/58c240611100000f065abb5a' : url;
        },
        /**
         * 主播列表［总榜、日榜］
         */
        getHostList() {
            
            return this.mockMode == 1 ? 'http://www.mocky.io/v2/5a0e91e830000085244335ed' : this.getOrigin() + '/event/gifts/integralList';
            // return 'http://www.mocky.io/v2/5a0e91e830000085244335ed';
            // return 'http://www.mocky.io/v2/5a0e91e830000085244335ed';
        },
        /**
         * 土豪榜单
         */
        getSendHostList() {

            return this.mockMode == 1 ? 'http://www.mocky.io/v2/58a570192900007d086d6a1d' : this.getOrigin() + '/event/gifts/sendIntegralList';
            
        },
        /**
         * 守护榜
         */
        getSendUserList: function(){
            return this.mockMode == 1 ? 'http://www.mocky.io/v2/58be947b260000bc16f07bb9' : this.getOrigin() + '/event/gifts/giftSendUserIntegralList';
        }
    };

    UpAct.CONFIG = CONFIG;

})(window, window['UpAct'] || (window['UpAct'] = {}));



// WEBPACK FOOTER //
// ./js/component/api/index.js